import type { FocPlanningPTourStepDef } from './focPlanningPTourTypes';

/**
 * Planning dashboard registers UI moves for all FOC 10.x Planning P tours.
 */
export type FocPlanningPTourApi = {
  getLocation?: () => { pathname: string; search: string };
  navigateTo?: (href: string) => void;
  setPlanningPhase?: (index: number) => void;
  ensureStepperOpen?: () => void;
  showPlanningAgenda?: () => void;
  selectPlanningWidget?: (widgetName: string) => void;
  openMeetingDetails?: () => void;
  scrollToTour?: (tour: string) => void;
};

let api: Partial<FocPlanningPTourApi> = {};

export function registerFocPlanningPTourApi(
  partial: Partial<FocPlanningPTourApi>
): () => void {
  api = { ...api, ...partial };
  return () => {
    for (const key of Object.keys(partial) as (keyof FocPlanningPTourApi)[]) {
      if (api[key] === partial[key]) {
        delete api[key];
      }
    }
  };
}

export function getFocPlanningPTourApi(): Partial<FocPlanningPTourApi> {
  return api;
}

export function prepareFocPlanningPStep(def: FocPlanningPTourStepDef | undefined) {
  if (!def) return;
  const host = getFocPlanningPTourApi();
  host.ensureStepperOpen?.();
  if (typeof def.phaseIndex === 'number') {
    host.setPlanningPhase?.(def.phaseIndex);
  }
  if (def.widget) {
    host.selectPlanningWidget?.(def.widget);
  }
  if (
    def.showAgenda ||
    def.tour === 'planning-agenda' ||
    def.tour === 'planning-show-agenda'
  ) {
    host.showPlanningAgenda?.();
  }
  if (def.openMeetingDetails || def.tour === 'planning-meeting-details') {
    window.setTimeout(() => host.openMeetingDetails?.(), 0);
  }
  if (def.tour) {
    host.scrollToTour?.(def.tour);
  }
}

export function resetFocPlanningPTourBridgeForTests() {
  api = {};
}
